import React, { useEffect, useState, createElement } from 'react';
import { Check, X, ArrowRight, ChevronDown, ChevronUp, ShieldCheck, Heart, Star, Play, Sparkles, Gift, ChevronLeft, ChevronRight } from 'lucide-react';
import { PurchasePopup } from '../components/PurchasePopup';
import { motion, AnimatePresence } from 'framer-motion';
// Images
const IMAGES = {
  kitCompleto: 'https://cdn.magicpatterns.com/uploads/7gdtFeBcjFfCWHz83XHHYr/ChatGPT_Image_28_ene_2026,_09_25_01_p.m._-_Editado.png',
  pack2: 'https://cdn.magicpatterns.com/uploads/hRweuY22pdTWXdF9XAk38K/Pack_2_final.png',
  pack3: 'https://cdn.magicpatterns.com/uploads/pKuNAhoEFL4XJ94XD5Bk4Q/Pack_3_Final.png',
  rostros: 'https://cdn.magicpatterns.com/uploads/1bQqb8feHBJub8fq3zu3e6/ChatGPT_Image_20_ene_2026,_06_38_33_p.m..png',
  garantia: 'https://cdn.magicpatterns.com/uploads/kAteJP3bb9bJE6XSrARb78/ChatGPT_Image_20_ene_2026,_06_41_42_p.m..png',
  socialProof: 'https://cdn.magicpatterns.com/uploads/ok6VRWaykLwfBd1PF4KcHs/ChatGPT_Image_20_ene_2026,_07_16_36_p.m..png'
};
const VIDEO_URL = 'https://cdn.magicpatterns.com/uploads/dHEC9UPoczrnwv3Rh3RA72/Grabacion_de_pantalla_2026-01-17_161211.undefined';
const CHECKOUT_URL = 'https://checkout.infinita-mente.online/';
const EBOOK_PAGES = ['https://cdn.magicpatterns.com/uploads/7HHSNyQk15QAhagBXLFVm3/Captura_de_pantalla_2026-01-21_150817.png', 'https://cdn.magicpatterns.com/uploads/uPwB7uhYHe3dYbThU7TG5n/Captura_de_pantalla_2026-01-21_151141.png', 'https://cdn.magicpatterns.com/uploads/4DEMoCTQTmRR8W8KhG6W5z/Captura_de_pantalla_2026-01-21_151201.png', 'https://cdn.magicpatterns.com/uploads/9ZHKEZNsBgz3X9CXsLyUTa/Captura_de_pantalla_2026-01-21_151237.png', 'https://cdn.magicpatterns.com/uploads/t5iUifziuTdRzW8zUe7vS8/Captura_de_pantalla_2026-01-21_151254.png'];
const PACKS = [{
  id: 1,
  title: 'Pack 1 — Método Esencial',
  oldPrice: '$39.999',
  price: '$14.999',
  savings: '$25.000',
  image: IMAGES.kitCompleto,
  ideal: 'Para empezar desde lo básico',
  checkoutUrl: 'https://checkout.infinita-mente.online/products/bajar-de-peso-sin-dejar-de-comer-dulces/42470739083362:1',
  includes: ['Ebook completo "Bajar de peso sin dejar de comer dulces"', 'Planificador de hábitos y organización', 'Recetario de postres saludables', 'Guía temática para el supermercado', 'Acceso de por vida']
}, {
  id: 2,
  title: 'Pack 2 — Método Acompañado',
  oldPrice: '$59.999',
  price: '$24.999',
  savings: '$35.000',
  image: IMAGES.pack2,
  recommended: true,
  badgeText: '⭐ MÁS ELEGIDO',
  ideal: 'Para tener más guía y menos dudas',
  checkoutUrl: 'https://checkout.infinita-mente.online/products/pack-metodo-acompanado-baja-de-peso-sin-dejar-los-dulces-con-guias-y-apoyo-extra/42474882760802:1',
  includes: ['Todo lo del Pack 1', 'Guías prácticas diarias', 'Ideas de comidas reales', 'Movimiento mínimo y opcional', 'Soporte prioritario']
}, {
  id: 3,
  title: 'Pack 3 — Kit Antisabotaje Completo',
  oldPrice: '$79.999',
  price: '$34.999',
  savings: '$45.000',
  image: IMAGES.pack3,
  badgeText: '👑 MEJOR VALOR',
  ideal: 'Para sostén emocional completo',
  checkoutUrl: 'https://checkout.infinita-mente.online/products/kit-antisabotaje-completo-para-dejar-de-empezar-de-cero-y-sostener-tu-proceso-de-verdad/42474886496354:1',
  includes: ['Todo lo del Pack 2', 'Protocolos antisabotaje emocional', 'Kit Anti-Culpa & Reorden', 'Soporte real y sin culpas', 'Acompañamiento extendido']
}];
const FAQS = [{
  q: '¿Y si no me funciona?',
  a: 'Tenés 7 días para probarlo. Si sentís que no es para vos, te devolvemos el 100% de tu dinero sin preguntas.'
}, {
  q: '¿Y si como de más?',
  a: 'El método incluye protocolos específicos para esos momentos. No se trata de perfección, sino de saber cómo retomar sin castigarte.'
}, {
  q: '¿Es una dieta?',
  a: 'No. Es un método realista que te enseña a integrar dulces sin culpa y a organizarte mejor. Sin prohibiciones ni exigencias irreales.'
}, {
  q: '¿Necesito fuerza de voluntad?',
  a: 'No. Necesitás un marco claro. El método te da estructura, no exigencias. La claridad reemplaza la fuerza de voluntad.'
}, {
  q: '¿Cuándo voy a ver resultados?',
  a: 'Muchas mujeres notan cambios en su relación con la comida desde la primera semana. Los cambios físicos dependen de cada organismo, pero la paz mental es inmediata.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'El acceso es 100% digital e inmediato. Una vez realizada la compra, recibirás un correo con todos los accesos para descargar el material.'
}];
const TESTIMONIOS = [{
  nombre: 'Sofía M.',
  edad: '34 años',
  ciudad: 'Buenos Aires',
  texto: 'Por primera vez entendí que el problema no era el dulce. Bajé 3kg sin sentir que estaba a dieta.',
  tiempo: 'hace 2 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/tPTzs7apBCJbBtXaeM5ZwZ/WhatsApp_Image_2026-01-20_at_20.39.50_(2).jpg'
}, {
  nombre: 'Laura P.',
  edad: '41 años',
  ciudad: 'Córdoba',
  texto: 'Dejé de sentir culpa y empecé a ordenar mi relación con la comida. Esto es lo que necesitaba.',
  tiempo: 'hace 1 semana',
  avatar: 'https://cdn.magicpatterns.com/uploads/vTTqwFVTYky9x11D3XA3cw/WhatsApp_Image_2026-01-20_at_20.39.50_(1).jpg'
}, {
  nombre: 'Carolina R.',
  edad: '29 años',
  ciudad: 'Rosario',
  texto: 'No me sentí a dieta. Me sentí acompañada. Y eso cambió todo.',
  tiempo: 'hace 3 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/uuKswkgBJUqfgTssz3gNBQ/WhatsApp_Image_2026-01-20_at_20.39.50.jpg'
}, {
  nombre: 'Mariana G.',
  edad: '38 años',
  ciudad: 'Mendoza',
  texto: 'Lo que más me gustó fue entender el tema de la ansiedad. Ahora sé cómo manejarlo sin prohibirme nada.',
  tiempo: 'hace 5 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/pXB74e6MhmUhKCA3KNE4Bf/WhatsApp_Image_2026-01-20_at_20.39.49.jpg'
}];
export function LandingPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [timeLeft, setTimeLeft] = useState({
    hours: 11,
    minutes: 59,
    seconds: 0
  });
  // Countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            hours: prev.hours,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Meta Pixel
  useEffect(() => {
    // Inject Meta Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1934048370513297');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Inject noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1934048370513297&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      // Cleanup on unmount
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % EBOOK_PAGES.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + EBOOK_PAGES.length) % EBOOK_PAGES.length);
  };
  return <div className="min-h-screen bg-gradient-to-b from-[#FFF5F5] to-white" data-id="element-12">
      {/* Urgency Bar - ELEGANTE Y REFINADA */}
      <div className="bg-gradient-to-r from-rose-500 to-orange-500 text-white py-1.5 px-4 text-center font-medium sticky top-0 z-50" data-id="element-13">
        <div className="flex items-center justify-center gap-2 text-xs" data-id="element-14">
          <span data-id="element-15">⏳ Oferta especial termina en</span>
          <div className="flex gap-1" data-id="element-16">
            <span className="bg-white/20 px-2 py-0.5 rounded text-[10px] font-semibold" data-id="element-17">
              {String(timeLeft.hours).padStart(2, '0')}h
            </span>
            <span className="bg-white/20 px-2 py-0.5 rounded text-[10px] font-semibold" data-id="element-18">
              {String(timeLeft.minutes).padStart(2, '0')}m
            </span>
            <span className="bg-white/20 px-2 py-0.5 rounded text-[10px] font-semibold" data-id="element-19">
              {String(timeLeft.seconds).padStart(2, '0')}s
            </span>
          </div>
        </div>
      </div>

      {/* 1. HERO */}
      <section className="relative py-4 md:py-6 px-4 overflow-hidden" data-id="element-20">
        <div className="max-w-7xl mx-auto" data-id="element-21">
          {/* PRUEBA SOCIAL VISUAL - EXTRA COMPACTA COMO REFERENCIA */}
          <div className="flex flex-col items-center gap-0 mb-2" data-id="element-22">
            <img src="https://cdn.magicpatterns.com/uploads/twpbZx95kxHMNzvWhXFxWH/ChatGPT_Image_26_ene_2026,_12_47_02_p.m._-_Editado.png" alt="Mujeres reales que ya eligieron este método" className="h-auto max-w-[60px] object-contain opacity-90" data-id="element-23" />
            <div className="flex items-center gap-0.5 mt-0.5" data-id="element-24">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-2 h-2 fill-yellow-400 text-yellow-400" data-id="element-25" />)}
              <span className="text-[9px] font-bold text-[#4A3B3B] ml-0.5" data-id="element-26">
                4.9/5 (+1.200)
              </span>
            </div>
          </div>

          {/* Título principal */}
          <h1 className="text-3xl md:text-5xl font-bold text-[#4A3B3B] mb-2 leading-tight text-center max-w-4xl mx-auto" data-id="element-27">
            Bajá de peso sin dejar de comer dulces
          </h1>

          {/* Subtítulo - ARRIBA DEL MOCKUP, MÁS PEQUEÑO */}
          <p className="text-sm md:text-base text-gray-700 mb-0.5 text-center max-w-2xl mx-auto leading-snug font-medium" data-id="element-28">
            El único método que te enseña a bajar de peso{' '}
            <span className="font-semibold text-[#C07776]" data-id="element-29">
              sin dietas extremas
            </span>
            , <span className="font-semibold text-[#C07776]" data-id="element-30">sin culpa</span> y{' '}
            <span className="font-semibold text-[#C07776]" data-id="element-31">
              para mujeres reales
            </span>
            .
          </p>

          {/* Simplified Urgency Banner - MÁS COMPACTO */}
          <div className="relative max-w-xl mx-auto -mb-6" data-id="element-32">
            <div className="bg-gradient-to-r from-rose-500 via-orange-500 to-rose-500 text-white py-1.5 px-4 rounded-lg shadow-md text-center" data-id="element-33">
              <p className="text-xs md:text-sm font-bold flex items-center justify-center gap-2" data-id="element-34">
                🔥 Últimas horas · 70% OFF
              </p>
            </div>
          </div>

          {/* Mockup KIT COMPLETO - GRANDE Y PROTAGONISTA */}
          <div className="flex flex-col items-center mb-4" data-id="element-35">
            <div className="relative inline-block" data-id="element-36">
              <button onClick={scrollToPurchase} className="group cursor-pointer transition-transform hover:scale-[1.02] duration-300 relative" data-id="element-37">
                <img src="https://cdn.magicpatterns.com/uploads/7gdtFeBcjFfCWHz83XHHYr/ChatGPT_Image_28_ene_2026,_09_25_01_p.m._-_Editado.png" alt="Kit Completo - Bajar de peso sin dejar de comer dulces" className="w-full max-w-md md:max-w-xl drop-shadow-2xl" data-id="element-38" />
                {/* Animated Discount Badge - EN LA ESQUINA DEL LIBRO PRINCIPAL */}
                <motion.div animate={{
                scale: [1, 1.05, 1]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="absolute top-[8%] right-[15%] bg-gradient-to-br from-red-500 to-rose-600 text-white rounded-full w-16 h-16 md:w-20 md:h-20 flex items-center justify-center shadow-xl border-4 border-white z-10" data-id="element-39">
                  <div className="text-center" data-id="element-40">
                    <div className="text-base md:text-lg font-black leading-tight" data-id="element-41">
                      70%
                    </div>
                    <div className="text-[10px] md:text-xs font-bold -mt-0.5" data-id="element-42">
                      OFF
                    </div>
                  </div>
                </motion.div>
              </button>
            </div>

            {/* Elegant Ribbon Below Mockup */}
            <div className="mt-2 max-w-xl px-4" data-id="element-43">
              <div className="bg-gradient-to-r from-[#E8B4B5] via-[#F5D5D6] to-[#E8B4B5] rounded-full px-4 py-1.5 shadow-md border border-[#E8B4B5]/50" data-id="element-44">
                <p className="text-center text-xs md:text-sm font-semibold text-[#4A3B3B]" data-id="element-45">
                  PACK COMPLETO – Incluye bonos, guías, recetas y protocolos
                </p>
              </div>
            </div>
          </div>

          {/* CTA Principal Premium */}
          <div className="flex flex-col items-center gap-3" data-id="element-46">
            <button onClick={scrollToPurchase} className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-xl md:text-2xl font-bold py-5 px-10 rounded-full shadow-2xl transform transition hover:scale-105 flex items-center gap-3" data-id="element-47">
              Quiero mi pack ahora
              <ArrowRight className="w-6 h-6" data-id="element-48" />
            </button>

            {/* Trust Indicators */}
            <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-gray-600" data-id="element-49">
              <div className="flex items-center gap-1.5" data-id="element-50">
                <Check className="w-4 h-4 text-green-600" data-id="element-51" />
                <span data-id="element-52">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-53">
                <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-54" />
                <span data-id="element-55">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-56">
                <Check className="w-4 h-4 text-green-600" data-id="element-57" />
                <span data-id="element-58">Pago 100% seguro</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. EL PROBLEMA REAL (PUESTA EN SITUACIÓN) */}
      <section className="py-20 bg-white px-4" data-id="element-59">
        <div className="max-w-4xl mx-auto" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-bold text-[#4A3B3B] mb-8 text-center" data-id="element-61">
            El problema real
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-62">
            <p data-id="element-63">
              Querés bajar de peso. Querés verte bien. Pero también querés comer
              algo rico.
            </p>
            <p data-id="element-64">Y en tu cabeza aparecen estas preguntas:</p>

            <div className="bg-[#FFF5F5] rounded-xl p-8 space-y-4 border border-[#E8B4B5]/30" data-id="element-65">
              <p className="italic" data-id="element-66">"¿Por qué a mí me cuesta tanto?"</p>
              <p className="italic" data-id="element-67">"¿Soy yo el problema?"</p>
              <p className="italic" data-id="element-68">"¿Tan difícil es verse bien?"</p>
              <p className="italic" data-id="element-69">"¿Verme bien significa pasarla mal?"</p>
            </div>

            <p className="font-medium" data-id="element-70">
              Arrancás con ganas, pero no sabés cómo sostenerlo.
            </p>
            <p data-id="element-71">Llegás cansada del trabajo y comés cualquier cosa.</p>
            <p data-id="element-72">Te das un gusto y después sentís culpa.</p>
            <p data-id="element-73">Pensás que si no lo hacés perfecto, no vale la pena.</p>

            <div className="bg-white rounded-xl p-8 border-l-4 border-[#C07776] mt-8" data-id="element-74">
              <p className="text-xl font-bold text-[#4A3B3B] mb-4" data-id="element-75">
                No. No sos vos.
              </p>
              <p className="text-lg" data-id="element-76">
                El problema es el enfoque. Nos enseñaron que comer rico no es
                compatible con adelgazar. Que los dulces son el enemigo. Que si
                no te controlás, fracasás.
              </p>
            </div>

            <p className="text-center text-xl font-medium text-[#8B4A4B] mt-8" data-id="element-77">
              Pero ese sistema no funciona en la vida real.
            </p>
          </div>
        </div>
      </section>

      {/* 3. PARA QUIÉN ES / PARA QUIÉN NO ES */}
      <section className="py-20 bg-[#FFF5F5] px-4" data-id="element-78">
        <div className="max-w-5xl mx-auto" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-bold text-[#4A3B3B] mb-12 text-center" data-id="element-80">
            ¿Para quién es este método?
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-81">
            {/* Para Quién ES */}
            <div className="bg-white rounded-2xl p-8 border border-green-200 shadow-lg" data-id="element-82">
              <h3 className="text-2xl font-bold text-green-700 mb-6 flex items-center gap-3" data-id="element-83">
                <Check className="w-7 h-7" data-id="element-84" />
                Para quién ES
              </h3>
              <ul className="space-y-4" data-id="element-85">
                {['Querés bajar de peso sin vivir a dieta', 'Te gustan los dulces y no querés eliminarlos', 'Te sentís perdida a la hora de comer', 'Estás cansada de empezar de cero', 'Querés algo que se adapte a tu vida real', 'Buscás claridad, no más exigencia'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-86">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-87" />
                    <span className="text-gray-700" data-id="element-88">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Para Quién NO ES */}
            <div className="bg-white rounded-2xl p-8 border border-red-200 shadow-lg" data-id="element-89">
              <h3 className="text-2xl font-bold text-red-700 mb-6 flex items-center gap-3" data-id="element-90">
                <X className="w-7 h-7" data-id="element-91" />
                Para quién NO ES
              </h3>
              <ul className="space-y-4" data-id="element-92">
                {['Buscás resultados mágicos en 7 días', 'Querés una dieta estricta y rápida', 'No estás dispuesta a aprender sobre tu cuerpo', 'Preferís prohibir antes que entender', 'Buscás fitness extremo o sacrificio constante', 'No querés cambiar tu relación con la comida'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-93">
                    <X className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" data-id="element-94" />
                    <span className="text-gray-700" data-id="element-95">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-10 text-center bg-white rounded-xl p-6 border border-[#E8B4B5]/30" data-id="element-96">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-97">
              No importa si trabajás todo el día. No importa si ya probaste de
              todo.{' '}
              <span className="font-bold text-[#4A3B3B]" data-id="element-98">
                Importa que querés hacerlo distinto.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* 4. QUÉ ES ESTE MÉTODO */}
      <section className="py-20 bg-white px-4" data-id="element-99">
        <div className="max-w-5xl mx-auto" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-bold text-[#4A3B3B] mb-6 text-center" data-id="element-101">
            ¿Qué es este método?
          </h2>
          <p className="text-xl text-gray-600 mb-10 text-center max-w-3xl mx-auto" data-id="element-102">
            Un método práctico y amable que te enseña a tomar decisiones con la
            comida desde la claridad, no desde la culpa.
          </p>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-103">
            {[{
            icon: '🍬',
            title: 'Integrar dulces sin miedo',
            desc: 'Aprendés a incluirlos en tu día sin sabotear tu progreso. No se trata de prohibir, sino de entender porciones y momentos.'
          }, {
            icon: '⚖️',
            title: 'Salir del todo o nada',
            desc: 'Dejás de pensar en blanco y negro con la comida. Un día imperfecto no arruina tu proceso.'
          }, {
            icon: '📋',
            title: 'Organizarte mejor',
            desc: 'Estructura clara para tu día a día real. Sin planes imposibles ni exigencias de Instagram.'
          }, {
            icon: '💪',
            title: 'Sostener el proceso',
            desc: 'Incluso cuando no es una semana perfecta. Porque la vida real tiene cansancio, estrés y antojos.'
          }].map((item, i) => <div key={i} className="bg-[#FFF5F5] rounded-xl p-8 border border-[#E8B4B5]/30 hover:shadow-lg transition" data-id="element-104">
                <div className="text-5xl mb-4" data-id="element-105">{item.icon}</div>
                <h3 className="text-xl font-bold text-[#4A3B3B] mb-3" data-id="element-106">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-107">{item.desc}</p>
              </div>)}
          </div>

          <p className="text-center text-lg text-gray-600 mt-10" data-id="element-108">
            Todo explicado paso a paso, sin prohibiciones ni exigencias
            irreales.
          </p>
        </div>
      </section>

      {/* 5. QUÉ NO ES ESTE MÉTODO */}
      <section className="py-20 bg-[#FFF5F5] px-4" data-id="element-109">
        <div className="max-w-4xl mx-auto" data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-bold text-[#4A3B3B] mb-8 text-center" data-id="element-111">
            Qué NO es este método
          </h2>

          <div className="bg-white rounded-2xl p-8 border border-[#E8B4B5]/30 shadow-lg" data-id="element-112">
            <div className="space-y-6" data-id="element-113">
              {[{
              title: 'No es una dieta restrictiva',
              desc: 'No te vamos a prohibir grupos de alimentos ni a pedirte que comas solo lechuga.'
            }, {
              title: 'No es un plan de fitness extremo',
              desc: 'No necesitás entrenar 2 horas por día ni hacer cardio en ayunas.'
            }, {
              title: 'No es fuerza de voluntad',
              desc: 'No se trata de "aguantar" o "controlarte". Se trata de entender y decidir.'
            }, {
              title: 'No promete resultados mágicos',
              desc: 'No vas a bajar 10kg en 2 semanas. Esto es realista, sostenible y humano.'
            }].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-114">
                  <X className="w-6 h-6 text-[#C07776] flex-shrink-0 mt-1" data-id="element-115" />
                  <div data-id="element-116">
                    <h3 className="font-bold text-[#4A3B3B] mb-2" data-id="element-117">
                      {item.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-118">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* 6. CÓMO TE VAS A SENTIR */}
      <section className="py-20 bg-white px-4" data-id="element-119">
        <div className="max-w-5xl mx-auto" data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-bold text-[#4A3B3B] mb-6 text-center" data-id="element-121">
            Cómo te vas a sentir cuando lo apliques
          </h2>
          <p className="text-xl text-gray-600 mb-12 text-center" data-id="element-122">
            Esto no es teoría. Es cómo se siente tu vida cuando dejás de
            pelearte con la comida.
          </p>

          <div className="space-y-8" data-id="element-123">
            {[{
            emoji: '☕',
            escena: 'En el desayuno',
            texto: 'Vas a poder elegir qué comer sin miedo. Sin pensar "esto engorda" o "esto está prohibido". Vas a disfrutar tu café con algo rico, sabiendo que está dentro de tu plan.'
          }, {
            emoji: '🍫',
            escena: 'Cuando tenés antojo de algo dulce',
            texto: 'No vas a sentir culpa. Vas a saber si podés comerlo ahora, cuánto, y cómo acomodarlo en tu día. Sin drama, sin castigo.'
          }, {
            emoji: '🍽️',
            escena: 'En una cena con amigas',
            texto: 'Vas a poder elegir sin ansiedad. No vas a ser "la que está a dieta". Vas a disfrutar la comida y la compañía, sin sentir que arruinaste todo.'
          }, {
            emoji: '🛌',
            escena: 'Antes de dormir',
            texto: 'No vas a irte a la cama pensando "mañana arranco de nuevo". Vas a sentir que el día estuvo bien, aunque no haya sido perfecto.'
          }].map((item, i) => <div key={i} className="bg-[#FFF5F5] rounded-xl p-8 border border-[#E8B4B5]/30" data-id="element-124">
                <div className="flex items-start gap-4" data-id="element-125">
                  <div className="text-4xl" data-id="element-126">{item.emoji}</div>
                  <div data-id="element-127">
                    <h3 className="text-xl font-bold text-[#4A3B3B] mb-3" data-id="element-128">
                      {item.escena}
                    </h3>
                    <p className="text-gray-700 leading-relaxed" data-id="element-129">
                      {item.texto}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center bg-white rounded-xl p-8 border-l-4 border-[#C07776]" data-id="element-130">
            <p className="text-2xl font-bold text-[#4A3B3B] mb-4" data-id="element-131">
              No es magia. Es claridad.
            </p>
            <p className="text-lg text-gray-600" data-id="element-132">
              Y la claridad te devuelve el control sin exigirte perfección.
            </p>
          </div>
        </div>
      </section>

      {/* 7. DEMOSTRACIÓN DEL PRODUCTO (CARRUSEL DE IMÁGENES) */}
      <section className="py-20 bg-[#FFF5F5] px-4" data-id="element-133">
        <div className="max-w-6xl mx-auto" data-id="element-134">
          <div className="text-center mb-10" data-id="element-135">
            <h2 className="text-3xl md:text-4xl font-bold text-[#4A3B3B] mb-4" data-id="element-136">
              Mirá una parte de lo que vas a encontrar dentro del método
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-137">
              Una vista real del contenido para que sepas exactamente qué estás
              comprando.
            </p>
          </div>

          {/* Carousel */}
          <div className="relative mb-10" data-id="element-138">
            {/* Desktop: Show 2-3 images */}
            <div className="hidden md:block" data-id="element-139">
              <div className="relative overflow-hidden" data-id="element-140">
                <div className="flex transition-transform duration-500 ease-out gap-6" style={{
                transform: `translateX(-${currentSlide * 50}%)`
              }} data-id="element-141">
                  {EBOOK_PAGES.map((page, i) => <div key={i} className="min-w-[calc(50%-12px)] flex-shrink-0" data-id="element-142">
                      <img src={page} alt={`Página ${i + 1} del ebook`} className="w-full h-auto rounded-lg shadow-xl" data-id="element-143" />
                    </div>)}
                </div>
              </div>

              {/* Navigation Arrows */}
              <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-3 rounded-full shadow-lg transition" aria-label="Anterior" data-id="element-144">
                <ChevronLeft className="w-6 h-6 text-[#4A3B3B]" data-id="element-145" />
              </button>
              <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-3 rounded-full shadow-lg transition" aria-label="Siguiente" data-id="element-146">
                <ChevronRight className="w-6 h-6 text-[#4A3B3B]" data-id="element-147" />
              </button>
            </div>

            {/* Mobile: Show 1 image */}
            <div className="md:hidden" data-id="element-148">
              <div className="relative" data-id="element-149">
                <img src={EBOOK_PAGES[currentSlide]} alt={`Página ${currentSlide + 1} del ebook`} className="w-full h-auto rounded-lg shadow-xl" data-id="element-150" />

                {/* Navigation Arrows */}
                <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition" aria-label="Anterior" data-id="element-151">
                  <ChevronLeft className="w-5 h-5 text-[#4A3B3B]" data-id="element-152" />
                </button>
                <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition" aria-label="Siguiente" data-id="element-153">
                  <ChevronRight className="w-5 h-5 text-[#4A3B3B]" data-id="element-154" />
                </button>
              </div>
            </div>

            {/* Dots indicator */}
            <div className="flex justify-center gap-2 mt-6" data-id="element-155">
              {EBOOK_PAGES.map((_, i) => <button key={i} onClick={() => setCurrentSlide(i)} className={`w-2 h-2 rounded-full transition-all ${i === currentSlide ? 'bg-[#C07776] w-8' : 'bg-gray-300'}`} aria-label={`Ir a página ${i + 1}`} data-id="element-156" />)}
            </div>
          </div>

          {/* Bottom text and CTA */}
          <div className="text-center" data-id="element-157">
            <p className="text-xl text-[#4A3B3B] font-medium mb-6 max-w-3xl mx-auto" data-id="element-158">
              Este no es un ebook motivacional. Es un método práctico, claro y
              aplicable desde el primer día.
            </p>
            <button onClick={scrollToPurchase} className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-lg font-bold py-4 px-10 rounded-full shadow-lg transform transition hover:scale-105 inline-flex items-center gap-3" data-id="element-159">
              Quiero acceder al método
              <ArrowRight className="w-5 h-5" data-id="element-160" />
            </button>
          </div>
        </div>
      </section>

      {/* Scarcity Band - Moved here, before packs */}
      <section className="bg-gradient-to-r from-rose-50 to-orange-50 border-y border-rose-200 py-4 px-4" data-id="element-161">
        <div className="max-w-4xl mx-auto text-center" data-id="element-162">
          <p className="text-base md:text-lg font-semibold text-rose-700 flex items-center justify-center gap-2" data-id="element-163">
            🚨 Atención: últimos 17 cupos con 70% de descuento
          </p>
        </div>
      </section>

      {/* 8. COMPRA (PACKS) */}
      <section id="compra" className="py-20 bg-white px-4" data-id="element-164">
        <div className="max-w-7xl mx-auto" data-id="element-165">
          <div className="text-center mb-16" data-id="element-166">
            <h2 className="text-4xl md:text-5xl font-bold text-[#4A3B3B] mb-6" data-id="element-167">
              Qué vas a recibir
            </h2>
            <p className="text-xl text-gray-600" data-id="element-168">
              No estás comprando solo un ebook. Estás accediendo a un sistema
              completo.
            </p>
          </div>

          {/* Bonos Incluidos */}
          <div className="mb-16" data-id="element-169">
            <div className="text-center mb-10" data-id="element-170">
              <span className="inline-block bg-[#C07776] text-white px-6 py-2 rounded-full text-sm font-bold mb-4" data-id="element-171">
                INCLUIDO EN TODOS LOS PACKS
              </span>
              <h3 className="text-2xl font-bold text-[#4A3B3B]" data-id="element-172">
                Bonos del Pack Esencial
              </h3>
            </div>

            <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-173">
              {[{
              title: 'Planificador de hábitos',
              desc: 'Para estructurar tu semana sin improvisación',
              icon: '📋'
            }, {
              title: 'Recetario de postres',
              desc: 'Dulces ricos que no sabotean tu progreso',
              icon: '🍰'
            }, {
              title: 'Guía para el super',
              desc: 'Qué comprar para tener opciones reales',
              icon: '🛒'
            }].map((bono, i) => <div key={i} className="bg-[#FFF5F5] rounded-2xl p-8 border border-[#E8B4B5]/30 text-center" data-id="element-174">
                  <div className="text-5xl mb-4" data-id="element-175">{bono.icon}</div>
                  <h4 className="text-xl font-bold text-[#4A3B3B] mb-3" data-id="element-176">
                    {bono.title}
                  </h4>
                  <p className="text-gray-600" data-id="element-177">{bono.desc}</p>
                </div>)}
            </div>
          </div>

          {/* Packs */}
          <div className="grid md:grid-cols-3 gap-8" data-id="element-178">
            {PACKS.map(pack => <div key={pack.id} className={`relative rounded-3xl p-8 transition-all duration-300 flex flex-col ${pack.recommended ? 'bg-white border-4 border-[#C07776] shadow-2xl scale-105 ring-8 ring-[#C07776]/5' : 'bg-white border border-gray-200 shadow-xl'}`} data-id="element-179">
                {/* Launch Price Badge */}
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-4 py-1 rounded-full text-xs font-bold shadow-md" data-id="element-180">
                  🔥 PRECIO DE LANZAMIENTO
                </div>

                {pack.badgeText && <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-[#C07776] text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg uppercase flex items-center gap-2" data-id="element-181">
                    {pack.badgeText}
                  </div>}

                <div className="mb-6 -mx-4 -mt-4" data-id="element-182">
                  <button onClick={scrollToPurchase} className="w-full cursor-pointer" data-id="element-183">
                    <img src={pack.image} alt={pack.title} className="w-full h-64 object-cover rounded-t-3xl" data-id="element-184" />
                  </button>
                </div>

                <h3 className="text-2xl font-bold text-[#4A3B3B] mb-2 text-center" data-id="element-185">
                  {pack.title}
                </h3>

                <div className="bg-[#FFF5F5] rounded-lg py-3 px-4 mb-6 text-center border border-[#E8B4B5]/30" data-id="element-186">
                  <p className="text-sm font-medium text-[#8B4A4B]" data-id="element-187">
                    {pack.ideal}
                  </p>
                </div>

                <div className="text-center mb-6" data-id="element-188">
                  <div className="flex flex-col items-center justify-center" data-id="element-189">
                    <span className="text-gray-400 line-through text-base font-medium mb-1" data-id="element-190">
                      Antes {pack.oldPrice}
                    </span>
                    <div className="text-5xl font-bold text-[#4A3B3B] mb-2" data-id="element-191">
                      {pack.price}
                    </div>
                    <span className="text-sm font-bold text-green-600" data-id="element-192">
                      Ahorrás {pack.savings}
                    </span>
                  </div>
                </div>

                <div className="border-t border-gray-100 my-6" data-id="element-193"></div>

                <div className="mb-8 flex-grow" data-id="element-194">
                  <p className="font-bold text-[#4A3B3B] mb-4" data-id="element-195">Incluye:</p>
                  <ul className="space-y-3" data-id="element-196">
                    {pack.includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-197">
                        <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-198" />
                        <span className="text-gray-700 text-sm" data-id="element-199">{item}</span>
                      </li>)}
                  </ul>
                </div>

                {/* Bonos incluidos */}
                <div className="bg-green-50 rounded-lg p-4 mb-6 border border-green-100" data-id="element-200">
                  <div className="flex items-center gap-2 mb-2" data-id="element-201">
                    <Gift className="w-5 h-5 text-green-600" data-id="element-202" />
                    <p className="font-bold text-green-800 text-sm" data-id="element-203">
                      Bonos incluidos solo por hoy
                    </p>
                  </div>
                  <p className="text-xs text-green-700" data-id="element-204">
                    Sin costo adicional. Acceso inmediato.
                  </p>
                </div>

                <a href={pack.checkoutUrl} className={`w-full py-5 text-lg rounded-xl font-bold text-center transition-all duration-300 transform hover:scale-[1.02] shadow-md flex items-center justify-center gap-2 ${pack.recommended ? 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white' : 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white'}`} data-id="element-205">
                  Elegir este pack
                  <ArrowRight className="w-5 h-5" data-id="element-206" />
                </a>

                <div className="mt-6 flex flex-col items-center justify-center gap-3" data-id="element-207">
                  <img src={IMAGES.garantia} alt="Garantía de 7 días" className="w-24 h-auto" data-id="element-208" />
                  <p className="text-xs text-center text-gray-500 max-w-[200px] leading-tight" data-id="element-209">
                    Probá el método durante 7 días. Si no es para vos, te
                    devolvemos el dinero.
                  </p>
                </div>
              </div>)}
          </div>

          {/* Time-limited notice */}
          <div className="mt-8 text-center" data-id="element-210">
            <p className="text-sm text-gray-500" data-id="element-211">
              ⏰ Precio de lanzamiento disponible por tiempo limitado
            </p>
          </div>

          {/* Trust and Security Section - FINAL */}
          <div className="mt-16 pt-12 border-t border-gray-200" data-id="element-212">
            <h3 className="text-2xl font-bold text-center text-[#4A3B3B] mb-8" data-id="element-213">
              Pago 100% seguro y confiable
            </h3>

            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-214">
              <div className="text-center p-6 bg-blue-50 rounded-xl" data-id="element-215">
                <ShieldCheck className="w-12 h-12 text-blue-600 mx-auto mb-3" data-id="element-216" />
                <p className="font-bold text-gray-800 mb-2" data-id="element-217">Mercado Pago</p>
                <p className="text-sm text-gray-600" data-id="element-218">
                  Pago 100% seguro procesado por Mercado Pago
                </p>
              </div>
              <div className="text-center p-6 bg-green-50 rounded-xl" data-id="element-219">
                <Check className="w-12 h-12 text-green-600 mx-auto mb-3" data-id="element-220" />
                <p className="font-bold text-gray-800 mb-2" data-id="element-221">Garantía 7 días</p>
                <p className="text-sm text-gray-600" data-id="element-222">
                  Probá sin riesgo, devolución total
                </p>
              </div>
              <div className="text-center p-6 bg-purple-50 rounded-xl" data-id="element-223">
                <Sparkles className="w-12 h-12 text-purple-600 mx-auto mb-3" data-id="element-224" />
                <p className="font-bold text-gray-800 mb-2" data-id="element-225">Acceso inmediato</p>
                <p className="text-sm text-gray-600" data-id="element-226">
                  Descargá todo al instante
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 9. DE DÓNDE NACE ESTE MÉTODO */}
      <section className="py-20 bg-white px-4" data-id="element-227">
        <div className="max-w-4xl mx-auto" data-id="element-228">
          <h2 className="text-3xl md:text-4xl font-bold text-[#4A3B3B] mb-8 text-center" data-id="element-229">
            De dónde nace este método
          </h2>

          <div className="bg-[#FFF5F5] rounded-2xl p-10 border border-[#E8B4B5]/30" data-id="element-230">
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-231">
              <p data-id="element-232">
                Este método nace de escuchar a cientos de mujeres que decían lo
                mismo:
              </p>
              <p className="italic text-[#8B4A4B] font-medium" data-id="element-233">
                "Quiero bajar de peso, pero no sé cómo hacerlo sin sufrir."
              </p>
              <p data-id="element-234">
                Mujeres que trabajaban, que tenían poco tiempo, que querían
                verse bien pero también disfrutar de la comida.
              </p>
              <p data-id="element-235">
                Mujeres que estaban cansadas de sentir culpa cada vez que comían
                algo rico.
              </p>
              <p className="font-medium" data-id="element-236">
                Y nos dimos cuenta de algo: el problema no era la falta de
                información. El problema era la falta de claridad.
              </p>
              <p data-id="element-237">
                Por eso creamos un método que no te exige perfección. Que no te
                prohíbe nada. Que te enseña a decidir desde la tranquilidad, no
                desde el miedo.
              </p>
              <p className="text-xl font-bold text-[#4A3B3B] text-center mt-8" data-id="element-238">
                Este método existe para que puedas verte bien sin pasarla mal.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 10. PRUEBA SOCIAL (TESTIMONIOS) */}
      <section className="py-20 bg-[#FFF5F5] px-4" data-id="element-239">
        <div className="max-w-4xl mx-auto" data-id="element-240">
          <h2 className="text-3xl md:text-4xl font-bold text-[#4A3B3B] mb-12 text-center" data-id="element-241">
            Lo que dicen otras mujeres
          </h2>

          <div className="space-y-6" data-id="element-242">
            {TESTIMONIOS.map((testimonial, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: i * 0.1
          }} className={`flex gap-4 ${i % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`} data-id="element-243">
                <img src={testimonial.avatar} alt={testimonial.nombre} className="w-12 h-12 rounded-full flex-shrink-0 object-cover" data-id="element-244" />
                <div className={`max-w-[80%] p-5 rounded-2xl shadow-sm ${i % 2 === 0 ? 'bg-white rounded-tl-none border border-gray-200' : 'bg-[#E8B4B5]/20 rounded-tr-none border border-[#E8B4B5]'}`} data-id="element-245">
                  <div className="flex items-center gap-2 mb-2" data-id="element-246">
                    <p className="text-sm font-bold text-gray-700" data-id="element-247">
                      {testimonial.nombre}
                    </p>
                    <span className="text-xs text-gray-500" data-id="element-248">•</span>
                    <p className="text-xs text-gray-500" data-id="element-249">
                      {testimonial.edad}, {testimonial.ciudad}
                    </p>
                  </div>
                  <p className="text-gray-800 leading-relaxed mb-2" data-id="element-250">
                    "{testimonial.texto}"
                  </p>
                  <p className="text-xs text-gray-400 text-right" data-id="element-251">
                    {testimonial.tiempo}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* 11. FAQ */}
      <section className="py-20 bg-white px-4" data-id="element-252">
        <div className="max-w-3xl mx-auto" data-id="element-253">
          <h2 className="text-3xl md:text-4xl font-bold text-[#4A3B3B] mb-10 text-center" data-id="element-254">
            Preguntas frecuentes
          </h2>
          <div className="space-y-4" data-id="element-255">
            {FAQS.map((faq, i) => <div key={i} className="border border-[#E8B4B5]/30 bg-white rounded-xl overflow-hidden shadow-sm" data-id="element-256">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition" data-id="element-257">
                  <span className="font-bold text-[#4A3B3B] pr-4" data-id="element-258">{faq.q}</span>
                  {openFaq === i ? <ChevronUp className="w-5 h-5 text-[#C07776] flex-shrink-0" data-id="element-259" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-260" />}
                </button>
                <AnimatePresence data-id="element-261">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-262">
                      <div className="p-5 bg-gray-50 text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-263">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </section>

      {/* 12. CTA FINAL */}
      <section className="py-20 bg-[#4A3B3B] text-white px-4 text-center relative overflow-hidden" data-id="element-264">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-265"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-266">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-267">
            No necesitás más exigencia.
            <br data-id="element-268" />
            Necesitás claridad.
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-269">
            Elegí el nivel de acompañamiento que mejor se adapte a vos y empezá
            desde un lugar más amable.
          </p>
          <button onClick={scrollToPurchase} className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-xl font-bold py-6 px-16 rounded-full shadow-2xl transform transition hover:scale-105 inline-flex items-center gap-3 ring-4 ring-green-500/30" data-id="element-270">
            Elegir cómo empezar
            <ArrowRight className="w-6 h-6" data-id="element-271" />
          </button>
          <div className="mt-8 flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-272">
            <ShieldCheck className="w-5 h-5 text-green-400" data-id="element-273" />
            <span data-id="element-274">Compra 100% Segura • Garantía de 7 días</span>
          </div>
        </div>
      </section>

      <footer className="bg-[#2D2424] text-white py-12 px-4 text-center border-t border-gray-800" data-id="element-275">
        <p className="opacity-50 text-sm" data-id="element-276">
          © {new Date().getFullYear()} Infinitamente. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}